export { getTranslation } from "./getTranslation.server";
export { useTranslation } from "./useTranslation.client";
export * from "./i18n.config";
export * from "./i18n.types";
export type { Dictionary } from "./__generated__/dictionary";
export { useI18n } from "./useI18n/useI18n";
export {
  mapCountryToLocale,
  parseAcceptLanguage,
  resolveLocaleFromHeader,
} from "./resolveLocale/resolveLocale";
